module.exports = __webpack_public_path__ + "static/media/HstarGift.423e562f.jpg";